import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './Divider.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function Divider() {
  return /*#__PURE__*/React.createElement("span", {
    className: cx('article')
  });
}

export { Divider as default };
